import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseClassListAll } from 'src/app/Models/output.model/ResponseClassListAll';
import { RequestBase } from 'src/app/Models/input.model/RequestBase';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { ResponseGetInfo } from 'src/app/Models/output.model/ResponseGetInfo';
import { AppConfiguration, AppConfig } from 'src/configuration';
@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(@Inject(AppConfig) private readonly appConfig: AppConfiguration,
    private http : HttpClient) { }


  GetInfo(RequestBase : RequestBase, token) : Observable<ResponseGetInfo>{
    return this.http.post<ResponseGetInfo>(this.appConfig.TeacherUrl + 'Profile/GetInfo',RequestBase,{
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${token}`)
    } ).pipe(map(z=> {return z}))
}

UpdateInfo(UserName, token, m, data) : Observable<ResponseGetInfo>{
  let dt = {
    'UserName': UserName,
    'Data': data,
  }
  return this.http.post<ResponseGetInfo>(this.appConfig.TeacherUrl + 'Profile/UpdateInfo',dt,{
    headers: new HttpHeaders()
      .set('Authorization', `Bearer ${token}`)
  } ).pipe(map(z=> {return z}))
  // try {
  //   $.ajax({
  //     type: "POST",
  //     url: this.appConfig.TeacherUrl + "Profile/UpdateInfo",
  //     dataType: "json",
  //     async: false,
  //     data: {
  //       'UserName': UserName,
  //       'Data': data,
  //     },
  //     beforeSend: function (xhr, settings) { xhr.setRequestHeader('Authorization', 'Bearer ' + token) },
  //     success: function (data) {
  //       m = data;
  //     },
  //     error: function (err) {
  //       if(err.status ==401){
  //         m.Status = 401;
  //       }
  //       m.Status = 3;
  //     },
  //   });
  // }
  // catch (err) {
  //   m.Status = 3;
  // }
  // finally {
  //   return m;
  // }
}

}
